/**
 * Prospecting Tour
 *
 * Introduces users to prospecting workflows — discovery, leads,
 * sequences, and deal pipeline management.
 */

import type { TourConfig } from './tour-config.types';

export const prospectingTour: TourConfig = {
  id: 'prospecting-overview',
  title: 'tours.prospecting.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="prospecting-discovery"]',
      content: 'tours.prospecting.steps.discovery',
      placement: 'bottom',
      route: '/prospecting/discovery',
    },
    {
      target: '[data-astor-id="prospecting-leads-table"]',
      content: 'tours.prospecting.steps.leads',
      placement: 'bottom',
      route: '/prospecting/leads',
    },
    {
      target: '[data-astor-id="prospecting-sequences"]',
      content: 'tours.prospecting.steps.sequences',
      placement: 'bottom',
      route: '/prospecting/sequences',
    },
    {
      target: '[data-astor-id="deals-pipeline"]',
      content: 'tours.prospecting.steps.deals',
      placement: 'bottom',
      route: '/deals',
    },
  ],
};
